import styled from "styled-components";
import theme from "../common/theme";

export default styled.div`
    padding: 1rem;
    border: 1px solid ${theme.palette.border};
    background: ${theme.palette.border};
    color: ${theme.palette.dark};
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1rem;
`